import * as React from 'react'
import { Base_Component } from '../Base/Base.ui.Component'
import type { RenderCachedImage } from '../../../app-core/lib/image/WithCachedImage'
import { Imag_withCachedImageUrl } from '../Imag/Imag.ui.withCachedImageUrl'

interface Props {
    url: string
    className?: string
    defaultUrl?: string
}

/**
 * A class API to render cached images
 */
export class Imag_CachedImage extends Base_Component<Props, {}> {
    public tryRender() {
        return Imag_renderCachedImage(this.props.url, this.props.className, this.props.defaultUrl)
    }
}

/**
 * A function API to render cached images that can be passed as a dependency more easily
 */
export const Imag_renderCachedImage: RenderCachedImage = (url: string, className?: string, defaultUrl?: string) =>
    Imag_withCachedImageUrl(url, (src) => <img src={src} className={className} />, defaultUrl)
